module.exports = __webpack_public_path__ + "img/88_20.df2acb85.png";